import { BI_CARDS } from "@/components/booking-home/BookingHomeCards";

const API = process.env.REACT_APP_BACKEND_URL;

export const ACCENT = {
  bookings: "#7a0f1d", pickup: "#0b5a2e", catering: "#123b8a", event: "#62115a", tiffin: "#0c5e69", "ganesh-modak": "#8a4f10",
  "corporate-invoices": "#43208a", "gift-vouchers": "#78101d", tables: "#8a6a1f", dashboard: "#8a6a1f", reminders: "#8a6a1f",
  "live-queue": "#7a0f1d", overlap: "#7a0f1d", history: "#7a0f1d",
};
export const GOLD_FILL = "linear-gradient(160deg,#fff4d1,#f1d38c 45%,#dcb25e 80%,#f6e1a4)";
export const EXTRA_TITLES = { "live-queue": "Live Queue", overlap: "Overlaps", history: "History" };

export const moduleMeta = (tab) => {
  const c = BI_CARDS.find((x) => x.tab === tab);
  return { title: c?.title || EXTRA_TITLES[tab] || "Booking Intelligence", icon: c?.icon, fill: c?.light ? GOLD_FILL : c?.fill || GOLD_FILL, light: !c || !!c.light, accent: ACCENT[tab] || "#7a0f1d" };
};

export const wsFetch = async (token, body) => {
  const r = await fetch(`${API}/api/booking-workspace/overview`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, ...body }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Could not load");
  return d;
};

export const todayIST = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);

export const TABLE_STATUS = {
  available: { label: "Available", cls: "bg-emerald-600 text-white border-emerald-800" },
  reserved: { label: "Reserved", cls: "bg-[#7a0f1d] text-[#fff3c4] border-[#4a080e]" },
  occupied: { label: "Occupied", cls: "bg-amber-500 text-[#3b1d00] border-amber-700" },
  cleaning: { label: "Cleaning", cls: "bg-stone-400 text-stone-900 border-stone-600" },
  out_of_service: { label: "Unavailable", cls: "bg-stone-300 text-stone-700 border-stone-500" },
  unavailable: { label: "Unavailable", cls: "bg-stone-300 text-stone-700 border-stone-500" },
};
